export const PUBLISHED_PRACTITIONER_NOTE_QUERY_KEY =
  'published-practitioner-note';
export const PRACTITIONER_NOTE_QUERY_KEY = 'practitioner-note';
